import { always, identity } from '@kofno/piper';
import { Maybe, fromEmpty } from 'maybeasy';
import { chatMetadataStore } from '../../../../Chatbot/ChatStores/ChatMetadataStore';
import {
  LearningCollectionOut,
  NewPreviewResource,
  ProductCollectionOut,
  SourceIdentifier,
} from '../Types';

export const previewLearningCollectionEncoder = (
  resource: NewPreviewResource,
  buttonMode: 'publishing' | 'creating' | 'save-and-editing',
  internalName: Maybe<string>,
): LearningCollectionOut => {
  const {
    search,
    name,
    description,
    default_product_collection,
    recommended_product_collection,
    browse_all,
  } = resource.payload;

  const defaultCollection: ProductCollectionOut = {
    name: default_product_collection.name.getOrElseValue('New Product Collection'),
    description: default_product_collection.description
      .map<string | undefined>(identity)
      .getOrElseValue(undefined),
    experiences: default_product_collection.experiences,
    display_type: default_product_collection.display_type,
    learning_design_state: default_product_collection.learning_design_state,
  };

  const featuredCollection: ProductCollectionOut = {
    name: recommended_product_collection.name.getOrElseValue('Featured Programs'),
    description: recommended_product_collection.description
      .map<string | undefined>(identity)
      .getOrElseValue(undefined),
    experiences: recommended_product_collection.experiences,
    display_type: recommended_product_collection.display_type,
    learning_design_state: 'browse-all',
  };

  const learningDesigns: ProductCollectionOut[] = fromEmpty(
    recommended_product_collection.experiences,
  )
    .map(always([featuredCollection, defaultCollection]))
    .getOrElse(always([defaultCollection]));

  const sourceIdentifier = (): SourceIdentifier => {
    switch (chatMetadataStore.assistantRole) {
      case 'coach':
        return 'coaching-profiles';
      case 'default':
        return 'exo-chat';
    }
  };

  return {
    learning_collection: {
      name: name.getOrElseValue('New Learning Collection'),
      description: description.map<string | undefined>(identity).getOrElseValue(undefined),
      search: search,
      browse_all: browse_all,
      internal_name: internalName.map<string>(identity).getOrElseValue(''),
      learning_designs: learningDesigns,
      ...(buttonMode === 'publishing' && { published: true }),
      source_identifier: sourceIdentifier(),
      assistant_role: chatMetadataStore.assistantRole,
      course_registration_id: chatMetadataStore.courseRegistrationId
        .map<number | undefined>(identity)
        .getOrElseValue(undefined),
      product_license_id: chatMetadataStore.selectedProductLicense
        .map<number | undefined>((license) => license.id)
        .getOrElseValue(undefined),
    },
  };
};
